import { usePortalComponent } from "@/components/PortalComponentWrapper";
import { Button } from "@/components/shadcn/button";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/shadcn/tooltip";
import useUniversalRouter from "@/hooks/use-universal-router";
import { Boxes } from "lucide-react";

const PortalComponentToggle = () => {
  const { isHighlighting, toggleHighlight, hasComponents } =
    usePortalComponent();
  const { pathname } = useUniversalRouter();

  const isOnPlaygroundPage = pathname.includes("sesamy-components");
  const isDisabled = isOnPlaygroundPage || !hasComponents;

  const button = (
    <Button
      onClick={toggleHighlight}
      disabled={isDisabled}
      variant="outline"
      size="icon"
      title={
        !isDisabled
          ? isHighlighting
            ? "Hide portal components"
            : "Highlight portal components"
          : undefined
      }
    >
      <Boxes />
    </Button>
  );

  if (isDisabled) {
    const tooltipText = isOnPlaygroundPage
      ? "Not available on playground pages"
      : "No portal components on screen";

    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="inline-block">{button}</span>
        </TooltipTrigger>
        <TooltipContent>{tooltipText}</TooltipContent>
      </Tooltip>
    );
  }

  return button;
};

export default PortalComponentToggle;
